import { actions } from './actions'

const initialState = {
  loading: false,
  errors: {},
}

export default function Reducer(state = initialState, action) {
  // console.log('state', state);
  // console.log('action', action);
  switch (action.type) {
    case actions.REQUEST:
      return {
        ...state,
        loading: true,
        errors: {},
      }
    case actions.SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case actions.ERROR:
      return {
        ...initialState,
        ...action.payload,
      }
    case actions.RESET:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
